"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Publisher = void 0;
const tslib_1 = require("tslib");
const zen_observable_ts_1 = tslib_1.__importDefault(require("zen-observable-ts"));
class Publisher {
    constructor() {
        this.rx = new zen_observable_ts_1.default(observe => {
            this.observe = observe;
        });
        this.publish = (item) => {
            if (this.observe && !this.observe.closed) {
                this.observe.next(item);
                this.lastValue = item;
            }
        };
        this.error = (error) => this.observe && !this.observe.closed && this.observe.error(error);
        this.subscribe = (observer) => {
            if (this.observe && !this.observe.closed) {
                if (this.lastValue) {
                    observer(this.lastValue);
                }
                return this.rx.subscribe(observer);
            }
            return null;
        };
    }
}
exports.Publisher = Publisher;
